import { useMemo } from "react";
import {
  Chip,
  IconButton,
  Stack,
  Typography,
  TypographyProps,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";

type SectionHeaderProps = {
  title: string;
  showUnPushedDataBadge?: boolean;
  backUrl?: string;
} & Pick<TypographyProps, "sx" | "gutterBottom">;

const SectionHeader = ({ title, sx, gutterBottom = true, showUnPushedDataBadge = true, backUrl = "/trigger-push" }: SectionHeaderProps) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const isUnpushedData = useMemo(() => showUnPushedDataBadge && searchParams.has("updatedSince"), [searchParams, showUnPushedDataBadge]);

  // If unpushed data badge should be shown, wrap in Stack with back button and badge
  if (isUnpushedData) {
    return (
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        mb={gutterBottom ? 2 : 0}
      >
        <IconButton
          onClick={() => navigate(backUrl)}
          size="small"
          sx={{
            color: "text.primary",
          }}
        >
          <ArrowBack />
        </IconButton>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom={false}
          sx={sx}
        >
          {title}
        </Typography>
        <Chip
          label="Unpushed Data"
          color="warning"
          size="small"
          sx={{
            fontWeight: 600,
            height: 28,
          }}
        />
      </Stack>
    );
  }

  // Default rendering without badge
  return (
    <Typography
      variant="h4"
      component="h1"
      gutterBottom={gutterBottom}
      sx={sx}
    >
      {title}
    </Typography>
  );
};

export default SectionHeader;
